module.exports = {"610503001":"华州街道","610503101":"杏林镇","610503102":"赤水镇","610503103":"高塘镇","610503104":"大明镇","610503105":"瓜坡镇","610503106":"莲花寺镇","610503107":"柳枝镇","610503108":"下庙镇","610503109":"金堆镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610503.json
// module id = 2822
// module chunks = 0